import { render, staticRenderFns } from "./DiscoverySettings.vue?vue&type=template&id=143d73f4&scoped=true"
import script from "./DiscoverySettings.vue?vue&type=script&lang=js"
export * from "./DiscoverySettings.vue?vue&type=script&lang=js"
import style0 from "./DiscoverySettings.vue?vue&type=style&index=0&id=143d73f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d73f4",
  null
  
)

export default component.exports